export default "__VITE_ASSET__Xf_3voHn__"